<script>
    import Header from "../components/Header.svelte";
    import LearnMore from "../components/LearnMore.svelte";
    import MessageBox from "../components/MessageBox.svelte";
    import WhiteButton from "../components/WhiteButton.svelte";
    import CenterThis from "../components/CenterThis.svelte";
    import TfaControls from "../components/TfaControls.svelte";
    import BendService from "../services/BendService";
    import EncryptionService from "../services/EncryptionService";
    import { writable } from 'svelte/store'
    import SecretService from "../services/SercetService";
    import {push} from 'svelte-spa-router'
    import {onMount} from "svelte";

    let buttonDisabled = false;

    let tfaPhoneStore = writable(null);
    let tfaEnabledStore = writable(false);
    let messageStore = writable(null);

    const messageInputId = 'submit-message-box';
    const phoneInputId = 'submit-phone-box';

    async function generate() {

        let phoneInputElem = document.getElementById(phoneInputId);
        let messageInputElem = document.getElementById(messageInputId);

        const secret = SecretService.getSecret();
        const encryptedMessage = await EncryptionService.encrypt(secret, $messageStore);

        if(!messageInputElem.reportValidity()) return;

        if($tfaEnabledStore) {
            let phoneLengthValidity = phoneInputElem.value.length === 12 ? '' : 'Please Enter a valid 10-digit phone number';
            phoneInputElem.setCustomValidity(phoneLengthValidity);
            if(!phoneInputElem.reportValidity()) {
                setTimeout(() => phoneInputElem.setCustomValidity(''), 50);
                return;
            }
        }

        buttonDisabled = true;

        BendService.post('save-message', {
            message: encryptedMessage,
            twoFactorRequired: $tfaEnabledStore,
            phoneNumber: $tfaEnabledStore ? $tfaPhoneStore : null,
        }).then(function(response) {
            push(`/l/${encodeURIComponent(response.token)}/${encodeURIComponent(EncryptionService.base64EncArr(secret))}`);
        }).finally(() => {
            buttonDisabled = false;
        })

    }

    onMount(function () {

    })

</script>

<section>
    <Header>Send a self-destructing message</Header>
    <LearnMore>
        BURN links lets you share secrets securely. Your message is encrypted and can be viewed only once by someone
        with the secure link. Once viewed, the message will self-destruct.
    </LearnMore>
    <MessageBox inputId={messageInputId} required={true} store={messageStore}/>
    <TfaControls inputId={phoneInputId} enabledStore={tfaEnabledStore} phoneStore={tfaPhoneStore}/>
    <CenterThis>
        <WhiteButton disabled={buttonDisabled} click={generate}>Generate Burn Link</WhiteButton>
    </CenterThis>
</section>
